import api from '../utils/api'

const inventoryService = {
  summary: async params => (await api.get('/api/inventory/summary',{params})).data.data || [],
  lots: async (productId,params) => (await api.get(`/api/inventory/products/${productId}/lots`,{params})).data.data || [],
  movements: async (productId,params) => (await api.get(`/api/inventory/products/${productId}/movements`,{params})).data.data || [],
  serials: async (productId,params) => (await api.get(`/api/inventory/products/${productId}/serials`,{params})).data.data || [],
  adjust: async (productId,data) => (await api.post(`/api/inventory/products/${productId}/adjust`,data)).data,
  confirmGoodsReceipt: async id => (await api.post(`/api/inventory/goods-receipts/${id}/confirm`)).data,
  reserveReceipt: async id => (await api.post(`/api/inventory/receipts/${id}/reserve`)).data,
  fulfillmentPreview: async id => (await api.get(`/api/inventory/receipts/${id}/fulfillment-preview`)).data.data,
  selectSerials: async (receiptId,itemId,serialIds) => (await api.put(`/api/inventory/receipts/${receiptId}/items/${itemId}/serials`,{serial_ids:serialIds})).data,
  confirmFulfillment: async (id,data) => (await api.post(`/api/inventory/receipts/${id}/confirm-fulfillment`,data)).data,
  resolveSerial: async (id,data) => (await api.post(`/api/inventory/serials/${id}/resolve`,data)).data,
  returns: async params => (await api.get('/api/inventory/sales-returns',{params})).data.data || [],
  createReturn: async data => (await api.post('/api/inventory/sales-returns',data)).data,
  confirmReturn: async id => (await api.post(`/api/inventory/sales-returns/${id}/confirm`)).data
}

export default inventoryService
